import { IConfig, SPEnvironment } from "@/config/config";
import { INavigation } from "@interfaces/ux/navigation.interface";
import { ILang, IMenuItem, UserDTO } from "@models/*";
import { BasePresenter } from "@presenters/base/base.presenter";
import { INavigationService, NavigationService } from "@services/proyecta/navigation.service";
import { ISessionService, SessionService } from "@services/proyecta/session.service";
import { useSelector } from "react-redux";
import { Enums, moment, String, Utilities, Constants } from "../../utils/utilities";

const config = require('@/config/config.json') as IConfig;

export class NavigationPresenter extends BasePresenter<INavigation> {
    private client: INavigationService;
    private clientSession: ISessionService;
    private currentLang: ILang;
    public params: any;

    constructor(view: INavigation) {
        super(view);
        this.client = new NavigationService();
        this.clientSession = new SessionService();
        this.currentLang = useSelector(this.context.sessionStore.selectLang);
        this.params = useSelector(this.context.sessionStore.selectParams);
    }
    private get currentLangId() {
        if (Utilities.isNullObject(this.currentLang)) {
            return 1;
        }
        return this.currentLang.id;
    }
    public async getLogo() {
        const logo = await this.client.getLogo();
        this.view.state.setLogo(logo);
    }
    public goToRoot = () => {
        this.context.history.push("/proyecta/presupuesto");
    }

    public redirectTo(relativeUrl: string) {
        if (!Utilities.isNullObject(relativeUrl)) {
            if (relativeUrl.indexOf('http') != -1) {
                window.location.replace(relativeUrl);
            }
            else {
                this.context.history.push(relativeUrl);
            }
        }
    }

    public async getMenuItems() {
        const items = await this.client.getMenuData(this.currentLangId);
        this.view.state.setItems(items);
    }
    public async getTopMenuItems() {
        const items = await this.client.getTopMenuData(this.currentLangId);
        this.view.state.setItems(items);
    }
    public getTotalPermissions(){
        const ADMIN_GROUP = this.params?.[Enums.Params.proyectaAdminModule]
        let userGroupsName: any[] = this?.currentUser?.userGroups?.map((x: any) => x.displayName)
    
        return (userGroupsName?.includes(ADMIN_GROUP))
    }

    public isActive(menuItem: IMenuItem): boolean {
        return menuItem.Title.toUpperCase() === "PROYECTA"
    }

    public toogleNavigation() {
        this.view.state.setMenuIsOpen(!this.view.state.menuIsOpen)
    }

    public get menuIsOpen() {
        return !this.view.state.menuIsOpen;
    }
    public get currentDate() {
        return moment.utc(new Date).tz(Constants.GeneralFormats.TIME_ZONE).format("DD MMMM YYYY");
    }

    public async getRoutes() {
        const routes = await this.clientSession.getRoutes(this.currentLangId);
        this.view.state.setRoutes(routes);
    }
    public get currentRoute() {
        const currentPathName = this.context.history.location.pathname.toUpperCase();
        
        let matchingRoute = this.view.state.routes.find(route => route["PRuta"].toUpperCase() === currentPathName);

        if (!matchingRoute) {
            matchingRoute = this.view.state.routes
                .filter(route => currentPathName.includes(route["PRuta"].toUpperCase())) 
                .reduce((longestMatch, route) => {
                    return route["PRuta"].length > (longestMatch["PRuta"] ? longestMatch["PRuta"].length : 0) ? route : longestMatch;
                }, {});
        }
    
        return matchingRoute;
    }
    
    public get title(): string {
        if (!Utilities.isNullObject(this.currentRoute)) {
            return this.currentRoute["PTitulo"];
        }
        return String.Empty;
    }
    public get subTitle(): string {
        if (!Utilities.isNullObject(this.currentRoute)) {
            return this.currentRoute["PSubTitulo"];
        }
        return String.Empty;
    }
    public get backTitle(): string {
        if (!Utilities.isNullObject(this.currentRoute)) {
            return this.currentRoute["PTituloAnterior"];
        }
        return String.Empty;
    }
    public goBack = () => {
        this.context.history.push(this.currentRoute["PRutaAnterior"])
    }

    public getEnvironment = () => {
        if (SPEnvironment.prod != config.environment) {
            let environment: string;
            switch (config.environment) {
                case SPEnvironment.local:
                    environment = "Local";
                    break;
                case SPEnvironment.pre:
                    environment = "Preproductivo";
                    break;
                case SPEnvironment.dev:
                    environment = "Desarrollo";
                    break;
            }
            return environment;
        }
    }

}